import Header from './header.js';
import Footer from './footer.js';
import Top from './top.js';
import Work from './work.js';
import Parallax from './parallax.js';
import * as Util from './util.js';
import "babel-polyfill";

(function() {
  const requestAnimationFrame =
  window.requestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.msRequestAnimationFrame;
  window.requestAnimationFrame = requestAnimationFrame;
})();

class App
{
  // ---------------------------------------------------------------------------------------------------------
	// --	App
	// ---------------------------------------------------------------------------------------------------------

  constructor(){

    //フラグ
    const holder = this;
    this.pageLoaded = false;
    this.fontLoaded = false;

    //VIEWPORTの設定
    var ua = navigator.userAgent;
    if((ua.indexOf('iPhone') > 0) || ua.indexOf('iPod') > 0 || (ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0)){
        $('head').prepend('<meta name="viewport" content="width=375, target-densitydpi=device-dp, user-scalable=no, shrink-to-fit=no">');
    } else {
        $('head').prepend('<meta name="viewport" content="width=1024, target-densitydpi=device-dp, user-scalable=no, shrink-to-fit=no">');
    }

    //WebFontのロード
    WebFont.load(
    {
      custom:
      {
        families: ['a-otf-midashi-go-mb31-pr6n', 'Montserrat']
      },
      loading: function()
      {
          // console.log('全てのWebフォントのロードが開始されたとき');
      },
      active: function()
      {
        // console.log('Webフォントのロード完了');
        holder.fontLoaded = true;
        holder.onLoad();
      },
      inactive: function()
      {
        // console.log('全てのWebフォントのロードが失敗したとき');
      }
    });

    //ヘッダー初期化
    this.header = new Header();

    //フッター初期化
    this.footer = new Footer();

    //TOP初期化
    if($("#top").length)
    {
      this.top = new Top();
    }

    //Work初期化
    if($("#work").length)
    {
      this.work = new Work();
    }

    //パララックス初期化
    $(".js-parallax-group").each(function(index){
      const parallax = new Parallax($(this));
    });

    //ロード
    $(window).on("load", (e)=>{
      this.pageLoaded = true;
      this.onLoad();
    });
    // window.onload = this.onLoad.bind(this);
  }


  /**
   * ロード完了
   */
  onLoad(){

    // console.log("onLoad");
    // console.log("pageLoaded:" + this.pageLoaded);
    // console.log("fontLoaded:" + this.fontLoaded);

    if(!this.pageLoaded || !this.fontLoaded) return;

    //ハッシュスクロール
    TweenMax.delayedCall(0.1, ()=>{
      if($("#top").length && location.hash)
      {
        Util.scrollTo(location.hash.split("#")[1], 0.2);
        history.replaceState('', document.title, window.location.pathname);
      }
      else
      {
        Util.scrollTo("", 0.2);
      }
    });

    //フェーダー
    const fader = $("#fader");
    const animation = fader.find(".animation");
    TweenMax.to(animation, 0.5, {alpha:0, ease:Power0.easeNone});
    TweenMax.to(fader, 0.5, {alpha:0, delay:0.5, ease:Power0.easeNone, onComplete:this.start.bind(this)});
  }


  /**
   * スタート
   */
  start(){

    $("#fader").remove();
    if(this.top) this.top.start();
    if(this.work) this.work.start();
  }



  // ---------------------------------------------------------------------------------------------------------
	// --	ループ処理
	// ---------------------------------------------------------------------------------------------------------

  /**
   * ループ処理
   */
  loop(){

    //loop
    requestAnimationFrame( () => {
      this.loop();
    });
  }

  // ---------------------------------------------------------------------------------------------------------
}

// var app;
$(function(){
  window.app = new App();
});
